<div class="c-logo" [style.width]="width">

</div>
